
import { ImageLink } from "../../utils/constants";
import dateformate from "../../helper/DateFormate";
import StatusBadge from "../../Components/StatusBadge";

const WishlistTable = ({ detail }) => {
 return (
  <div className="card-body p-0">
   <div className="table-responsive">
    <table className="table align-middle mb-0">
     <thead
      style={{
       background: "#f9fafb",
       fontSize: "14px",
      }}
     >
      <tr>
       <th className="ps-4">#</th>
       <th>Image</th>
       <th>Name</th>
       <th>SKU</th>
       <th>Type</th>
       <th>Price</th>
       <th>Date</th>
       <th></th>
      </tr>
     </thead>

     <tbody>
      {detail?.wishlists?.length > 0 ? (
       detail.wishlists.map((cart, index) => (
        <>
         <tr key={cart.id} className="table-row">
          <td className="ps-4 fw-semibold">{index + 1}</td>

          <td>
           <img
            src={ImageLink(cart.image)}
            alt=""
            style={{
             width: "100px",
             height: "100px",
             objectFit: "cover",
             objectPosition: "top center",
             borderRadius: "6px",
             border: "1px solid #eee",
            }}
           />
          </td>

          <td>
           <span className="fw-semibold text-dark">{cart.name}</span>
          </td>

          <td>
           <span className="fw-semibold text-dark">{cart.sku}</span>
          </td>

          <td>
           <StatusBadge status={cart.type} />
          </td>
          <td>
           <span className="text-dark">{cart.price}</span>
          </td>

          <td>
           <small className="text-dark">{dateformate(cart.createdAt)}</small>
          </td>

   
         </tr>
        
        </>
       ))
      ) : (
       <tr>
        <td colSpan="7" className="text-center py-5 text-muted">
         No Wishlist found
        </td>
       </tr>
      )}
     </tbody>
    </table>
   </div>
  </div>
 );
};

export default WishlistTable;
